import { type FC } from 'react'

import { algoliaProxyRecordAccessorGetDeeplink } from '../../../algolia'
import { experimentsCompeteraTrackCompeteraEvent } from '../../../experiments/competera-experiment/experimentsCompeteraTrackCompeteraEvent'
import { useExperimentsContext } from '../../../experiments/components/ExperimentsContext'
import {
  EXPERIMENTS_TRACK_EVENT_SEARCH_PAGE_PRODUCT_DETAIL_CLICK,
  EXPERIMENTS_TRACK_EVENT_SERP_COMPETERA,
  experimentsTrackEvent,
} from '../../../experiments/eventTracking'
import { useGetExperiment } from '../../../experiments/hooks'
import { EXPERIMENT_NAME_SEARCH_PAGE_REFINED_QUERY_SUGGESTIONS } from '../../../experiments/model/EXPERIMENT_NAME.ts'
import { useGlobalConfigContext } from '../../../global-config'
import { useProductSearchContext } from '../../context/productSearchContextValue.tsx'

import { useProductSearchResultItemContext } from './ProductSearchResultItemContext/productSearchResultItemContext'

export const ProductSearchResultItemTitle: FC = () => {
  const { algoliaRecord, query = '' } = useProductSearchResultItemContext()
  const { skipProductDeepLinkParams } = useProductSearchContext()

  const { experiments } = useExperimentsContext()
  const globalConfig = useGlobalConfigContext()
  const searchPageRefinedQuerySuggestionsExperiment = useGetExperiment(
    EXPERIMENT_NAME_SEARCH_PAGE_REFINED_QUERY_SUGGESTIONS,
  )
  const {
    __position: position,
    __queryID: queryID = '',
    offerId,
    productName,
  } = algoliaRecord

  return (
    // Switching to `NextLink` investigation under https://jira.shop-apotheke.com/browse/WSAWA-7078
    <a
      className="flex flex-1 self-stretch text-ellipsis text-s font-medium after:absolute after:inset-0 hover:underline"
      data-qa-id="serp-result-item-title"
      href={algoliaProxyRecordAccessorGetDeeplink({
        params: {
          eventName: 'click on product list item',
          offerId,
          position,
          query,
          queryID,
        },
        record: algoliaRecord,
        skipProductDeepLinkParams,
      })}
      onClick={(): void => {
        experimentsCompeteraTrackCompeteraEvent(
          experiments,
          globalConfig,
          EXPERIMENTS_TRACK_EVENT_SERP_COMPETERA,
        )
        if (searchPageRefinedQuerySuggestionsExperiment.isEnabled) {
          experimentsTrackEvent(
            globalConfig,
            EXPERIMENTS_TRACK_EVENT_SEARCH_PAGE_PRODUCT_DETAIL_CLICK,
          )
        }
      }}
    >
      {productName}
    </a>
  )
}
